<div class="container">
  <div class="content-wrapper">
    <div class="user-signup">
      <div #isNavigated>
        <div class="content-wrapper">
          <h5 class="modal-title fech_hed" id="exampleModalCenterTitle">
            Sign Up / Create Account
          </h5>

          <div class="col-lg-12 row mt-2">
            <div class="col-md-6">
              <button
                id="userbtn"
                type="button"
                class="btn btn-block btn-outline-primary"
                [class.active]="userType === 'user'"
                [disabled]="isDisabled"
                (click)="switchToUserOrAgent('user')"
              >
                User
              </button>
            </div>

            <div class="col-md-6">
              <button
                id="agentbtn"
                type="button"
                class="btn btn-block btn-outline-primary"
                (click)="switchToUserOrAgent('agent', true)"
              >
                Agent
              </button>
            </div>
          </div>

          <ng-container
            *ngTemplateOutlet="user"
          ></ng-container>
        </div>
      </div>
    </div>

    <ngx-spinner
      bdColor="rgba(51,51,51,0.8)"
      size="medium"
      color="#fff"
      type="ball-spin-clockwise"
      [fullScreen]="true"
    ></ngx-spinner>
  </div>
</div>


<!-- ========================================================= -->
<!-- USER SIGNUP TEMPLATE                                      -->
<!-- ========================================================= -->

<ng-template #user>
  <form
    [formGroup]="registrationForm"
    class="payment-form-wrapper"
    (ngSubmit)="onSubmit()"
  >
    <h3 class="mb-15 ml-1-enq mt-20">
      Embark on Your Personalized Journey!
    </h3>

    <p class="p-2 mb-10 text-justify">
      At Your Travel Booking, we believe that every travel experience is unique,
      just like you. By creating an account, you're not just signing up for a
      service – you're joining a community of adventurers seeking seamless
      travel solutions. Your personalized account is the key to unlocking
      exclusive deals, managing your bookings effortlessly, and modifying your
      journeys to perfection. Join us on this exciting expedition – sign up now,
      and let's turn your travel dreams into a reality, one account at a time!
    </p>

    <div class="pregistrationFormt-25 ph-30">
      <div class="row gap-20 mb-0 form-container">

        <!-- ================================================= -->
        <!-- USER ID                                           -->
        <!-- ================================================= -->

        <div class="col-md-12">
          <div class="form-group mt-15">
            <label>
              User ID
              <span class="help-block">*</span>
            </label>

            <input
              id="uniqueUserID"
              type="text"
              class="form-control form-bg-light"
              formControlName="UserId"
              minlength="6"
              maxlength="16"
              (keyup)="checkVal()"
              (blur)="checkUserIDExist()"
            />

            @if (
              getError(registrationForm.get('UserId'), 'User ID');
              as errorMsg
            ) {
              <span class="err-msg text text-danger">
                {{ errorMsg }}
              </span>
            }

            @if (isUserID) {
              <span class="err-msg text text-danger">
                User ID already exists
              </span>
            }
          </div>
        </div>


        <!-- ================================================= -->
        <!-- FIRST NAME                                        -->
        <!-- ================================================= -->

        <div class="col-md-6">
          <div class="form-group">
            <label>
              First Name
              <span class="help-block">*</span>
            </label>

            <input
              type="text"
              class="form-control form-bg-light"
              minlength="3"
              maxlength="26"
              (keypress)="allowOnlyChars($event)"
              formControlName="FirstName"
              aria-describedby="emailHelp"
            />

            @if (
              getError(
                registrationForm.get('FirstName'),
                'First Name'
              );
              as errorMsg
            ) {
              <span class="err-msg text text-danger">
                {{ errorMsg }}
              </span>
            }
          </div>
        </div>


        <!-- ================================================= -->
        <!-- MIDDLE NAME                                       -->
        <!-- ================================================= -->

        <div class="col-md-6">
          <div class="form-group">
            <label>Middle Name</label>

            <input
              type="text"
              class="form-control form-bg-light"
              minlength="3"
              maxlength="26"
              (keypress)="allowOnlyChars($event)"
              formControlName="MiddleName"
              aria-describedby="emailHelp"
            />

            @if (
              getError(
                registrationForm.get('MiddleName'),
                'Middle Name'
              );
              as errorMsg
            ) {
              <span class="err-msg text text-danger">
                {{ errorMsg }}
              </span>
            }
          </div>
        </div>


        <!-- ================================================= -->
        <!-- LAST NAME                                         -->
        <!-- ================================================= -->

        <div class="col-md-6">
          <div class="form-group">
            <label>
              Last Name
              <span class="help-block">*</span>
            </label>

            <input
              type="text"
              class="form-control form-bg-light"
              minlength="3"
              maxlength="20"
              (keypress)="allowOnlyChars($event)"
              formControlName="LastName"
              aria-describedby="emailHelp"
            />

            @if (
              getError(
                registrationForm.get('LastName'),
                'Last Name'
              );
              as errorMsg
            ) {
              <span class="err-msg text text-danger">
                {{ errorMsg }}
              </span>
            }
          </div>
        </div>


        <!-- ================================================= -->
        <!-- DATE OF BIRTH                                     -->
        <!-- ================================================= -->

        <div class="col-md-6">
          <div class="form-group flt-cal">
            <label>
              Date of birth
              <span class="font12">(ex: MM/DD/YYYY)</span>
              <span class="help-block">*</span>
            </label>

            <input
              type="text"
              class="form-control form-bg-light pr-0"
              placeholder="MM/DD/YYYY"
              NumbersOnly
              formControlName="dob"
              maxlength="10"
              (keyup)="dateOfBirthDate($event)"
              onPaste="return false"
              onCopy="return false"
            />

            @if (
              getError(
                registrationForm.get('dob'),
                'Date of Birth'
              );
              as errorMsg
            ) {
              <span class="err-msg text text-danger">
                {{ errorMsg }}
              </span>
            }
          </div>
        </div>


        <!-- ================================================= -->
        <!-- EMAIL                                             -->
        <!-- ================================================= -->

        <div class="col-sm-6">
          <div class="form-group">
            <label>
              Email Address
              <span class="help-block">*</span>
            </label>

            <input
              formControlName="Email"
              type="text"
              class="form-control form-bg-light"
              aria-describedby="emailHelp"
            />

            @if (
              getError(
                registrationForm.get('Email'),
                'Email'
              );
              as errorMsg
            ) {
              <span class="err-msg text text-danger">
                {{ errorMsg }}
              </span>
            }
          </div>
        </div>


        <!-- ================================================= -->
        <!-- PHONE NUMBER                                      -->
        <!-- ================================================= -->

        <div class="col-sm-6">
          <div class="form-group">
            <div class="row">

              <!-- PHONE CODE -->

              <div class="col-md-5 col-lg-5 col-sm-12 caremergency">
                <label>
                  Code
                  <span class="orange">(Optional)</span>
                </label>

                <div class="ui-grid ui-grid-responsive ui-fluid signup1">

                  <p-dropdown
                    class="signupphone form-control"
                    [style]="{ height: '50px' }"
                    [options]="countrycodes"
                    formControlName="phoneCodeiso2"
                    filter="true"
                    filterBy="label,value,iso2,iso3"
                  >

                    <!-- SELECTED PHONE CODE -->

                    <ng-template
                      let-phonecode
                      pTemplate="selectedItem"
                    >
                      <div class="phoneformatall2 cardetailswidth">

                        @if (phonecode.origionalvalue) {
                          <img
                            [src]="phonecode.origionalvalue"
                            alt="Image"
                          />
                        }

                        @if (!phonecode.value) {
                          <span>
                            {{ phonecode.label }}
                          </span>
                        }

                        @if (phonecode.iso2) {
                          <span>
                            + {{ phonecode.iso2 }}
                          </span>
                        }

                      </div>
                    </ng-template>


                    <!-- PHONE CODE DROPDOWN -->

                    <ng-template
                      let-i="index"
                      let-codes
                      pTemplate="phonecode"
                    >
                      <div
                        class="ui-helper-clearfix phoneformatall"
                      >
                        <div class="media">

                          <div class="media-left">
                            @if (codes.value) {
                              <img
                                [src]="codes.origionalvalue"
                                alt="Image"
                              />
                            }
                          </div>

                          <div class="media-body">
                            <p>
                              {{ codes.label }}

                              @if (codes.iso2) {
                                <span>
                                  + {{ codes.iso2 }}
                                </span>
                              }
                            </p>
                          </div>

                        </div>
                      </div>
                    </ng-template>

                  </p-dropdown>


                  @if (
                    getError(
                      registrationForm.get('phonecode'),
                      'Phone code'
                    );
                    as errorMsg
                  ) {
                    <span class="err-msg text text-danger">
                      {{ errorMsg }}
                    </span>
                  }

                </div>
              </div>


              <!-- PHONE NUMBER -->

              <div class="col-md-6 col-lg-7 pt-15 pt-lg-0">
                <label>
                  Phone Number
                  <span class="orange">(Optional)</span>
                </label>

                <div class="form-group">

                  <input
                    type="text"
                    formControlName="PhoneNumber"
                    name="cpwd"
                    class="form-control form-bg-light phonenumber"
                    (keypress)="allowOnlyNum($event)"
                  />

                  @if (
                    getError(
                      registrationForm.get('PhoneNumber'),
                      'Phone Number'
                    );
                    as errorMsg
                  ) {
                    <span class="err-msg text text-danger">
                      {{ errorMsg }}
                    </span>
                  }

                </div>
              </div>

            </div>
          </div>
        </div>


        <!-- ================================================= -->
        <!-- PASSWORD                                          -->
        <!-- ================================================= -->

        <div class="col-sm-6">
          <div class="form-group">
            <label>
              Password
              <span class="help-block">*</span>
            </label>

            <input
              formControlName="Password"
              name="pwd"
              type="password"
              class="form-control form-bg-light"
              maxlength="16"
            />

            @if (
              getError(
                registrationForm.get('Password'),
                'Password'
              );
              as errorMsg
            ) {
              <span class="err-msg text text-danger">
                {{ errorMsg }}
              </span>
            }
          </div>
        </div>


        <!-- ================================================= -->
        <!-- CONFIRM PASSWORD                                  -->
        <!-- ================================================= -->

        <div class="col-sm-6">
          <div class="form-group">
            <label>
              Confirm Password
              <span class="help-block">*</span>
            </label>

            <input
              formControlName="Confirmpassword"
              type="password"
              name="cpwd"
              class="form-control form-bg-light"
            />

            @if (
              getError(
                registrationForm.get('Confirmpassword'),
                'Confirm Password'
              );
              as errorMsg
            ) {
              <span class="err-msg text text-danger">
                {{ errorMsg }}
              </span>
            }
          </div>
        </div>

      </div>


      <!-- =================================================== -->
      <!-- TERMS AND CONDITIONS                               -->
      <!-- =================================================== -->

      <div class="row">
        <div class="col-md-12">

          <div class="form-group mb-2 ml-1-enq">
            <div class="custom-checkbox">

              <input
                id="flightSearchRadio"
                class="form-check-input"
                type="checkbox"
                formControlName="AcceptTerms"
                name="triptype"
              />

              <label
                class="form-check-label"
                for="flightSearchRadio"
              >
                By clicking "Create Your Account," you agree to our

                <a
                  routerLink="/privacy-policy"
                  target="_blank"
                  class="text-underline text-orange"
                >
                  Privacy Policy
                </a>

                and

                <a
                  routerLink="/terms-and-conditions"
                  target="_blank"
                  class="text-underline text-orange"
                >
                  Terms of Service
                </a>.

                Your journey begins here, and we can't wait to be a part of
                it with you!
              </label>

              <br />
            </div>


            @if (
              registrationForm.get('AcceptTerms')?.touched &&
              registrationForm.get('AcceptTerms')?.hasError('required')
            ) {
              <span class="err-msg text text-danger">
                You must accept terms & conditions
              </span>
            }

          </div>


          <!-- ================================================= -->
          <!-- SUCCESS / ERROR ALERTS                           -->
          <!-- ================================================= -->

          <div class="row">

            @if (showSuccess) {
              <div class="alert alert-successs">

                <button
                  type="button"
                  data-dismiss="alert"
                  aria-hidden="true"
                  class="close"
                >
                  ×
                </button>

                @for (
                  err of successMessageText;
                  track $index
                ) {
                  <li>
                    {{ err }}
                  </li>
                }

              </div>
            }


            @if (showFail) {
              <div class="alert alert-danger">

                <button
                  type="button"
                  data-dismiss="alert"
                  aria-hidden="true"
                  class="close"
                >
                  ×
                </button>

                @for (
                  err of successMessageText;
                  track $index
                ) {
                  <li>
                    {{ err }}
                  </li>
                }

              </div>
            }


            <!-- ================================================= -->
            <!-- CREATE ACCOUNT BUTTON                            -->
            <!-- ================================================= -->

            <div class="col-md-12 text-center">
              <div class="form-group">

                <button
                  type="submit"
                  class="btn btn-primary btn-lg mr-lg-3"
                >
                  Create Your Account
                </button>

              </div>
            </div>

          </div>


          <!-- ================================================= -->
          <!-- REGISTRATION SUCCESS MESSAGE                      -->
          <!-- ================================================= -->

          @if (showSuccess) {
            <div class="alert alert-success">
              Registration success, please check your mail
            </div>
          }


          <!-- ================================================= -->
          <!-- LOGIN                                             -->
          <!-- ================================================= -->

          <div class="">
            <div class="form-group mt-2">
              <div>
                <div class="" role="alert">

                  <span class="text-black">
                    Already have an account?
                  </span>

                  <a
                    #signin
                    class="font600 text-orange text-underline cursor"
                    data-toggle="modal"
                    data-target="#loginModal"
                    (click)="logIn()"
                    href=""
                  >
                    Click here to Login
                  </a>

                </div>
              </div>
            </div>
          </div>


          <!-- ================================================= -->
          <!-- SIGN-IN DYNAMIC CONTAINER                         -->
          <!-- ================================================= -->

          <ng-template #signincontainer></ng-template>

        </div>
      </div>

    </div>
  </form>
</ng-template>


<!-- ========================================================= -->
<!-- ADDRESS TEMPLATE                                          -->
<!-- ========================================================= -->

<ng-template #address>
</ng-template>